export default __webpack_public_path__ + "3310257b37370863f6b9e0142e9b64c2.png";